/**
 * @file 页面主入口文件 多页面使用
 * @description courseList app课程列表页
 */
import { HashRouter, Routes, Route } from 'react-router-dom';
import Live from './pages/Live';
import './App.css';

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route path="/" element={<Live />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
